import React, {Component} from 'react';
import ania from './assets/zespol/anna_jachimowicz.jpg'

export default class Team extends Component {
  constructor(props) {
    super(props);
    this.state = {
      team: props.data.team,
    }
  }

  render() {
    const {team} = this.state
    return (
      <>

        <section className="py-6 bg-gray-800 text-gray-100">
          <div className="container p-4 mx-auto space-y-16 sm:p-10">
            <h1 className="text-4xl font-bold leading-none text-center sm:text-5xl">Zespół Organizatorów</h1>
            <div className="grid w-full grid-cols-1 gap-x-6 gap-y-12 sm:grid-cols-2 lg:grid-cols-4">
              {team ? team.map((d, i) => (
                <div className="space-y-4">
                  <img alt="" className="object-cover h-56 mx-auto mb-4 bg-center rounded-sm bg-gray-500" src={d.path}/>
                  <div className="flex flex-col items-center">
                    <h4 className="text-xl font-semibold">{d.name}</h4>
                    <p className="text-sm text-gray-400">{d.title}</p>
                  </div>
                </div>)) : 'Loading'}
            </div>
          </div>
        </section>

      </>
    );
  }
  ;
}
